import { render, staticRenderFns } from "./taskDetailDialog.vue?vue&type=template&id=49c784b4&scoped=true&"
import script from "./taskDetailDialog.vue?vue&type=script&lang=js&"
export * from "./taskDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./taskDetailDialog.vue?vue&type=style&index=0&id=49c784b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c784b4",
  null
  
)

export default component.exports